import { CButton } from "@coreui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BasicSelect } from "src/components";

const AddNewQuestion = ({ className, handleAdd, areas }) => {
  const [areaIdx, setAreaIdx] = useState();

  const { t } = useTranslation();

  return (
    <div
      className={`d-flex align-self-start justify-content-between p-2 mb-3 align-items-center border bg-light rounded ${className}`}
    >
      <span style={{ width: "250px" }}>Add new question in:</span>
      <BasicSelect
        className=" mr-3 mb-0"
        placeholder={"Select area"}
        value={areaIdx}
        options={areas}
        onChange={(e) => setAreaIdx(e.target.value)}
        required
      />

      <CButton
        className="ml-3"
        color="success"
        variant="outline"
        onClick={() => handleAdd(areaIdx)}
        disabled={areaIdx === undefined}
      >
        {t("shared.add", "Add")}
      </CButton>
    </div>
  );
};

export default AddNewQuestion;
